module.exports = __webpack_public_path__ + "img/top3.9a7816c5.png";